<template>
  <div class="payment-form">
    <!--    <form-->
    <!--      id="payment-form"-->
    <!--      method="post">-->
    <div id="payment-form">
      <el-form
        ref="formNet"
        :rules="rules"
        :model="formNet">
        <template v-if="isFina">
          <div
            v-if="isCanNet"
            class="form-item">
            <span class="label">Total Payable</span>
            <div class="form-input" >
              <el-form-item
                ref="net_payable"
                :rules="rules.net_payable"
                prop="net_payable">
                <v-input
                  v-model.number="formNet.net_payable"
                  money
                  prepend="HKD"
                  @blur="handleSetNet" />
              </el-form-item>
            </div>
          </div>
        </template>
      </el-form>
      <el-form
        ref="form"
        :rules="rules"
        :model="formData">
        <template v-if="!isFina&&!isGuest">
          <v-checkbox
            v-model="isUseCredits"
            @change="changeUseCredits"
          >Use Hold Dollars</v-checkbox
          >
          <div
            class="credit-box"
            :class="{ 'mask-container': !isUseCredits }">
            <div class="flex-sb">
              <div class="form-item">
                <span>
                  Balance
                  <span class="name">{{ customerName }}</span>
                </span>
                <!--                <span class="amount">{{ money | formatMoney(2, true) }} </span>-->
                <span class="amount">{{ money }} </span>
                <!--              <p v-if="getFee>=4">-->

                <p
                  v-if="getFee >= 4"
                  class="warning-tip">
                  <font-awesome-icon icon="exclamation-triangle" />
                  {{
                    `Transactions under $ ${getFee} will incur a handdling fee.`
                  }}
                </p>
              </div>
              <el-form-item
                ref="credit"
                :rules="isUseCredits?rules.input:{}"
                prop="credit">
                <div class="input-box">
                  <v-input
                    v-model.number="credit"
                    prepend="$"
                    int
                    key-number
                    @keyEnter="handlerBlur"
                    @input="inputCredit"
                    @blur="handlerBlur"
                  />
                </div>
              </el-form-item>
            </div>
          </div>
        </template>
        <div
          v-if="false"
          class="select-pay">
          <el-radio
            v-model="selectPay"
            label="1"
            @change="handleSelectPay"
          ><span class="select-span">Online Payment</span></el-radio
          >
          <el-collapse-transition>
            <div
              v-show="selectPay == 1"
              class="form-half">
              <div class="flex pay-group margin-top">
                <div class="form-item">
                  <span class="label">Credit Card</span>
                  <div id="card-element"></div>
                </div>
              </div>
              <div
                v-if="selectPay == 1"
                class="form-item">
                <span class="label">Name</span>
                <div class="form-input">
                  <el-form-item
                    :rules="extraRules.cardHolderName"
                    prop="cardHolderName">
                    <v-input
                      v-model="formData.cardHolderName"
                      uppercase
                      :disabled="amount <= 0" />
                  </el-form-item>
                </div>
              </div>
              <p
                id="card-errors"
                style="color: red"></p>
            </div>
          </el-collapse-transition>
        </div>
        <div class="select-pay">
          <el-radio
            v-if="!isNewSME"
            v-model="selectPay"
            label="2"
            @change="handleSelectPay"
          ><span class="select-span"> Other Payment Methods</span></el-radio
          >
          <el-collapse-transition>
            <div
              v-if="selectPay == 2||isNewSME"
              class="margin-top form-half">
              <div class="form-item">
                <el-form-item prop="pay_type">
                  <span class="label">Method</span>
                  <div class="form-input">
                    <v-select
                      v-model="formData.pay_type"
                      :list="payOptions" />
                  </div>
                </el-form-item>
              </div>
              <div class="form-item">
                <el-form-item prop="transaction_date">
                  <span class="label">Transaction Date</span>
                  <div class="form-input i-datetime-picker">
                    <el-date-picker
                      v-model="formData.transaction_date"
                      format="dd-MM-yyyy HH:mm"
                      placeholder="dd-MM-yyyy HH:mm"
                      valueFormat="yyyy-MM-dd HH:mm"
                      type="datetime">
                    </el-date-picker>
                    <!--                    <v-datetime-picker-->
                    <!--                      v-model="formData.transaction_date" />-->
                  </div>
                </el-form-item>
              </div>
              <div class="form-item">
                <span class="label">Reference No.</span>
                <div class="form-input">
                  <v-input v-model="formData.reference_no" />
                </div>
              </div>
              <div class="form-item">
                <span>Proof</span>
                <!--              <el-form-item-->
                <!--                ref="proof_file_id"-->
                <!--                prop="proof_file_id">-->

                <v-upload
                  :card="true"
                  :fileData="formData.proof_file_id_pic"
                  :otherData="{
                    target: 'proof_file_id_pic',
                    idKey: 'proof_file_id',
                    nameKey: 'proof_file_id_path',
                  }"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerUploadDelete"
                />
                <!--              </el-form-item>-->
              </div>
              <div class="form-item">
                <span class="label">Remarks</span>
                <div class="form-input">
                  <v-input
                    v-model="formData.remark"
                    type="textarea"
                    :rows="4"
                  />
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>

        <div
          v-if="!isBusiness"
          class="form-item">
          <span class="label">Signature Link Send Method</span>
          <div class="form-input">
            <el-form-item
              prop="radio"
              :rules="rules.select">
              <v-radio-group
                v-model="formData.radio"
                :list="option" />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--    </form>-->

    <v-button
      v-show="amount > 0 && selectPay == 1"
      id="card-button"
      size="mini"
      type="success"
    >{{ payBtnContent }}</v-button
    >
    <v-button
      v-show="selectPay == 2 || amount <= 0"
      size="mini"
      type="success"
      @click="handlerPayAmount"
    >{{ payBtnContent }}</v-button>

    <send-email-sms
      ref="send-email-sms"
      :form="detail"
      :type="formData.radio == 1? 1: 2"
      :initContent="detail.url_data"
      :init-refer-content="detail.referrer_url_data"
      :is-fina="isFina"
      :emailListTitle="detail.url_list_title"
      :emailTitle="detail.need_sign_url_title"
      @send="handlerSend"
      @skip="handlerSkip"
      @close="handlerClose" />
    <send-contact-dialog
      v-model="showSMS"
      :form="detail"
      :contact-type="formData.radio == 1? 1: 3"
      is-payment
      is-quote
      :is-fina="isFina"
      @skip="handleSMESend"
      @send="handleSMESend"></send-contact-dialog>
  </div>
</template>

<script>
import {sendSMEPayment} from '@/api/new_sme'
import {paymentCheckout, setMgmDiscount} from '@/api/order'
import {getAccountClientWallet, getAccountDetail} from '@/api/account'
import MixinFormat from '@/mixins/format'
import MixinOption from '@/mixins/options'
import MixinRules from '@/mixins/rules'

import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import sendContactDialog from '@/views/sme/components/send-contact-dialog'
const env = require('../../../env')
import dayjs from 'dayjs'
export default {
  name: 'newPaymentForm',
  components: {
    SendEmailSms,
    sendContactDialog
  },
  mixins: [MixinFormat, MixinOption, MixinRules],
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: '',
    },
    customerId: {
      type: [String, Number],
      default: '',
    },
    customerName: {
      type: String,
      default: '',
    },
    haveCredit: {
      type: Boolean,
      default: true,
    },
    isFina: {
      type: Boolean,
      default: false,
    },
    transactionFee: {
      type: Number,
      default: 0,
    },
    amount: {
      type: Number,
      default: 0,
    },
    getCredit: {
      type: [Number, String],
      default: 0,
    },
    type: {
      type: [String],
      default: '',
    },
  },
  data() {
    const checkNetPayable = (rule, value, cb) => {
      let {max_payable=0,min_payable=0} =this.detail||{}
      if(value==''||value>max_payable||value<min_payable){
        cb(new Error(`輸入範圍${min_payable} ~ ${max_payable}`))
      }
      cb()
    }
    const checkRequire = (rule, value, callback) => {
      // 如果支付金额等于0，就跳过表单验证
      if(this.amount <= 0){
        callback()
      }
      if(!value){
        if(['cardHolderName'].includes(rule.fullField)){
          callback(new Error(this.$t('placeholder.input')))
        }
        if(['pay_type', 'transaction_date'].includes(rule.fullField)){
          callback(new Error(this.$t('placeholder.select')))
        }
      }
      callback()
    }
    return {
      selectPay: '2',
      showSMS: false,
      sme_send_data: '',
      cardElement: null,
      radio: '',
      stripe: null,
      lock: false,
      isUseCredits: false,
      credit: '',
      money: '',
      option: [
        {
          name: 'SMS',
          id: 1,
        },
        {
          name: 'Email',
          id: 2,
        },
      ],
      formData: {
        proof_file_id: '',
        reference_no: '',
        remark: '',
        pay_type: '',
        transaction_date: '',
        proof_file_id_pic: {},
        proof_file_id_path: '',
        radio: '',
        cardHolderName: '',
        credit:'',
      },
      resultForm: {},
      isSend: false,
      sendContent: '',
      extraRules:{
        cardHolderName: [
          { validator: checkRequire, trigger: ['change', 'blur'] },
        ],
        pay_type:[
          { validator: checkRequire, trigger: ['change', 'blur'] },
        ],
        transaction_date:[
          { validator: checkRequire, trigger: ['change', 'blur'] },
        ],
        net_payable: [
          {validator: checkNetPayable, trigger: ['change', 'blur']}
        ],
      },
      customerData:{},
      formNet:{net_payable:''},
    }
  },
  computed: {
    ticketId(){
      let {ticket_id} = this.detail||{}
      return ticket_id||''
    },
    getFee() {
      return this.transactionFee || 0
    },
    isBusiness() {
      // business ticket add policy payment
      return this.type == 'business'
    },
    payBtnContent() {
      if (this.isBusiness) {
        return 'Pay Now'
      }
      return 'Pay Now & Send Link'
    },
    isSMEProduct(){
      let {product_id} = this.$route.query
      return product_id>=80
    },
    isNewSME(){
      let {sme_versions} = this.$route.query||{}
      return sme_versions==3
    },
    isCanNet(){
      let {type} = this.detail||{}
      return [10,20].includes(type)
    },
    isGuest(){
      return this.customerId<=0
    }
  },
  watch: {
    selectPay:{
      immediate: true,
      handler(val) {

      },
    },
    isNewSME:{
      immediate: true,
      handler(val) {
        if(val){
          this.selectPay = 2
        }
      },
    },
    customerId: {
      immediate: true,
      handler(val, old) {
        if (val>0) {
          this.network().getAccountClientWallet()
          // if(this.isSMEProduct&&!this.isFina){
          //   this.network().getAccountDetail()
          // }
        }
      },
    },
    getCredit: {
      handler(val) {
        if (val != this.credit) {
          this.credit = val
        }
      },
    },
    amount: {
      immediate:true,
      handler(val) {
        this.formNet.net_payable = val||0
        let disabled = false
        this.$nextTick(()=>{
          if (val <= 0) {
            disabled = true
          }
          this.cardElement.update({
            disabled: disabled,
          })
        })

      },
    },
  },
  mounted() {
    this.stripe = null
    this.initPay()

  },
  activated() {
    this.lock = false
  },
  methods: {
    handleSetNet(){
      this.$refs.formNet.validate((valid, rules) => {
        if (valid) {
          this.network().setMgmDiscount()
        }
      })

    },
    handleSMESend(data){
      this.sme_send_data = data
      this.handlerSkip()
    },
    handleSelectPay(){
      this.$emit('changePayType',this.selectPay)
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path } = data
      if (type !== 'other') {
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, nameKey, path)
        this.$set(this.formData, target, data)
        this.$refs['form'].validateField(idKey)
      } else {
        if (index === '') {
          this.formData.other_file.push(data)
        } else {
          this.$set(this.formData.other_file, index, data)
        }
      }
    },
    handlerUploadDelete({ otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData

      if (type !== 'other') {
        this.$set(this.formData, idKey, '')
        this.$set(this.formData, nameKey, '')
        this.$set(this.formData, target, null)
        this.$refs['form'].validateField(idKey)
      }
    },
    handlerBlur() {
      console.log('this.credit', this.credit)
      this.$emit('handlerBlur', this.credit)
    },
    // amount 為 0 時不需要走 信用卡
    handlerPayAmount() {
      let params = {
        order_id: this.orderId,
      }
      if (this.isUseCredits && this.credit) {
        params.credit = this.credit
      }
      if (this.formData.radio) {
        params.sign_send_type = this.formData.radio
      }
      params.pay_method = this.selectPay
      if (this.selectPay == 2) {
        params = { ...params, ...this.formData }
      }
      if (this.amount <= 0) {
        params.pay_type = 1
        params.pay_method = 1
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          // this.network().paymentCheckout(params)
          this.resultForm = params
          if(this.isNewSME)
            this.showSMS = true
          else
            this.$refs['send-email-sms'].changeDialog()
        }
      })
      // this.network().paymentCheckout(params)
    },
    initPay() {
      // eslint-disable-next-line
      this.stripe = Stripe(env.PAY_KEY);
      const elements = this.stripe.elements({ locale: 'en' }) //// 设置默认显示语种   en 英文 cn 中文 auto 自动获取语种
      const style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '16px',
          color: '#32325d',
        },
      }
      this.cardElement = elements.create('card', {
        style,
        disabled: this.amount ? false : true,
        hidePostalCode: true,
      })

      this.cardElement.mount('#card-element')
      //  觸發表單校驗
      this.cardElement.addEventListener('change', ({ error }) => {
        const displayError = document.getElementById('card-errors')
        if (error) {
          displayError.textContent = error.message
        } else {
          displayError.textContent = ''
        }
      })

      const cardButton = document.getElementById('card-button')
      cardButton.addEventListener('click', (ev) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            console.log(ev)
            // this.$router.push('/quoting/payment/success')
            // return
            //
            // this.$refs['send-email-sms'].changeDialog()

            if (this.lock) return

            this.lock = true // 禁用按鈕

            // 額外參數
            let extraData = {
              billing_details: {},
            }
            if (this.formData.cardHolderName) {
              extraData.billing_details.name = this.formData.cardHolderName
            }

            this.stripe
              .createPaymentMethod('card', this.cardElement, extraData)
              .then((result) => {
                console.log(result)
                if (result.error) {
                  // Show error in payment form
                  this.$message(result.error.message)
                  this.lock = false
                } else {
                  let resultParams = {
                    payment_method_id: result.paymentMethod.id,
                    order_id: this.orderId,
                  }
                  if (this.isUseCredits && this.credit) {
                    resultParams.credit = this.credit
                  }
                  if (this.formData.radio) {
                    resultParams.sign_send_type = this.formData.radio
                  }
                  resultParams.pay_method = this.selectPay
                  resultParams.pay_type = 1

                  // this.network().paymentCheckout(resultParams)
                  this.resultForm = resultParams

                  this.$refs['send-email-sms'].changeDialog()

                }
              })

          }
        })
      })
    },
    inputCredit(val) {
      this.formData.credit = val
      // this.$emit('change-credit', val)
    },
    changeUseCredits(status) {
      const credit = status ? this.credit : 0
      if(!status){
        this.$refs.form.clearValidate()
      }
      this.$emit('change-credit', credit, status)
    },
    handlerSend(content,type,data) {
      this.isSend = true
      let {referrer_send,referrer_content,customer_send} =data
      this.sendContent = content
      let params = {
        content,
        referrer_content,
        is_send: 1
      }
      if(!customer_send) delete params.content
      if(!referrer_send) delete params.referrer_content
      this.network().paymentCheckout({
        ...this.resultForm,
        ...params
        // is_send: 1,
        // content
      })
      // this.$refs['send-email-sms'].changeDialog()
    },
    handlerSkip() {
      this.isSend = false
      this.sendContent = ''

      this.network().paymentCheckout({
        ...this.resultForm,
        content: '',
        is_send: 0
      })
      // this.$refs['send-email-sms'].changeDialog()
    },
    handlerClose() {
      this.lock = false
    },
    handler() {
      return {
        handlerPayment: (response) => {
          const { code } = response
          if (code && code != 1000) {
            // Show error from server on payment form
            // if (response.code == 4058) {
            //   this.$message('該訂單支付中或已支付，請勿重複支付')
            // }
            this.lock = false // 開啓按鈕
          } else if (response.requires_action) {
            // Use Stripe.js to handle required card action
            this.stripe
              .handleCardAction(response.payment_intent_client_secret)
              .then((result) => {
                if (result.code && result.code != 1000) {
                  // Show error in payment form
                  // alert(result.message)
                  this.lock = false // 開啓按鈕
                } else {
                  // The card action has been handled
                  // The PaymentIntent can be confirmed again on the server
                  // this.network().paymentCheckout({
                  //   payment_intent_id: result.paymentIntent.id,
                  //   order_id: this.$route.query.order_id
                  // })

                  let resultParams = {
                    payment_intent_id: result.paymentIntent.id,
                    order_id: this.orderId
                  }
                  if(this.isUseCredits && this.credit) {
                    resultParams.credit = this.credit
                  }
                  if(this.radio) {
                    resultParams.sign_send_type = this.radio
                  }
                  resultParams.pay_method  =this.selectPay
                  resultParams.pay_type  =1
                  this.network().paymentCheckout(resultParams)
                }
              })
          } else if (!code) {
            this.$message({
              type: 'error',
              message: 'ERROR!',
            })
          } else {
            this.$message({
              type: 'success',
              message: response.message_language
                ? response.message_language
                : response.message,
            })
            this.$emit('success', response)
            // this.$router.push({
            //   path: '/quotation'
            // })
          }
        },
      }
    },
    network() {
      return {
        paymentCheckout: async (params) => {
          try {
            let resultParams = {
              ...params,
            }

            let { data } = await paymentCheckout(resultParams)
            if(this.isNewSME)
              await this.network().sendSMEPayment()
            if (this.amount) {
              this.handler().handlerPayment(data)
            }
            // 不走 stripe
            else {
              const { code, message_language, message } = data
              if (!code) {
                this.$message({
                  type: 'error',
                  message: 'ERROR!',
                })
              } else {
                this.$message({
                  type: 'success',
                  message: message_language ? message_language : message,
                })
                this.$emit('success', data)
              }
            }
          } catch (e) {
            this.lock = false // 開啓按鈕
            console.log(e)
          }
        },
        getAccountClientWallet: async () => {
          const { data } = await getAccountClientWallet({
            client_id: this.customerId,
          })
          this.money = data.money
        },
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.customerId,
            hideLoading:true
          })
          this.customerData = data.customer_profile
        },
        sendSMEPayment:async (params)=>{
          let {data} = await sendSMEPayment({
            ...this.sme_send_data,
            ticket_id:this.ticketId
          })
        },
        setMgmDiscount: async () => {
          const { data } = await setMgmDiscount({
            order_id:this.orderId,
            ...this.formNet
          })
          this.$emit('update')
        },
      }
    },
  },
}
</script>
<style lang="scss">
.payment-form {
  padding-bottom: 100px;
  .pay-group {
    .form-item:first-child {
      flex: 1;
      margin-right: 10px;
    }
  }
  .img-payment {
    margin-top: 5px;
    width: 140px;
  }
  .credit-box {
    margin-left: 20px;
    margin-top: 5px;
    padding: 15px 15px 0 15px;
    background: #f6f8fa;
    border-radius: 4px;
    margin-bottom: 30px;
    .flex-sb {
      align-items: center;
    }
    .amount {
      color: #409eff;
      font-size: 24px;
      font-weight: bold;
    }
    .input-box {
      margin-top: -10px;
      width: 130px;
    }
  }
  .form-item {
    span {
      span {
        font-weight: 400;
      }
    }
    // padding-bottom: 15px;
    // span {
    //   color: #91939a;
    //   font-weight: 400;
    //   span {

    //   }
    // }
    // .label {
    //   display: block;
    //   padding-bottom: 7px;
    //   font-weight: 500;
    //   font-size: 14px;
    //   color: #616266;
    // }
    .accepts-list {
      display: flex;
      span {
        display: block;
        width: 44px;
        height: 30px;
      }
    }
  }
  .btn-confirm {
    display: block;
    margin: 20px auto;
    padding: 10px 25px;
    background: #ffc600;
    color: white;
    border-radius: 25px;
    border: 1px solid #fff;
    cursor: pointer;
  }
  .StripeElement {
    box-sizing: border-box;
    padding: 10px 12px;
    height: 40px;
    border: 1px solid transparent;
    border-radius: 4px;
    background-color: white;
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }
  .warning-tip {
    font-size: 12px;
    color: #dbab09;
    font-family: Inter;
    margin-top: 15px;
  }
  .select-pay {
    border: 1px solid #d1d5da;
    border-radius: 5px;
    background-color: #ffffff;
    padding: 20px;
    margin-bottom: 20px;
    .select-span {
      color: #24292e;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
    }
    .margin-top {
      margin-top: 20px;
    }
    .form-half {
      width: calc(100% - 170px);
    }
  }
}
.i-datetime-picker {
  width: 100%;
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-input__inner{
    height: 32px;
    line-height: 32px;
  }
  .el-input__icon{
    line-height: 32px;
  }
}
</style>
